'use strict';

const angular = require('angular');

module.exports = angular.module('spinnaker.core.notification.types.slack', [])
  .config(function(notificationTypeConfigProvider) {
    notificationTypeConfigProvider.registerNotificationType({
      label: 'Slack',
      key: 'slack',
      addressTemplateUrl: require('./additionalFields.html')
    });
  });



// WEBPACK FOOTER //
// ./app/scripts/modules/core/src/notification/types/slack/slack.notification.type.module.js